import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";

const ConfirmModal = () => {
  const confirmModal = useSelector((state) => state.confirmModal)
  return (
    <Modal show={confirmModal.show} onHide={confirmModal.onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{confirmModal.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{confirmModal.body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={confirmModal.onCancel}>
          Annulla
        </Button>
        <Button variant="primary" onClick={confirmModal.onConfirm}>
          Conferma
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmModal